import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { WhyLimitlessSection } from '../components/home/WhyLimitlessSection';
import { ProgramsOverview } from '../components/home/ProgramsOverview';
import { TrialSpotlight } from '../components/home/TrialSpotlight';
import { AreasServed } from '../components/home/AreasServed';
import { SocialProof } from '../components/home/SocialProof';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
export function HomePage() {
  return <main className="overflow-hidden" data-id="element-502">
      <HeroSection data-id="element-503" />
      <WhyLimitlessSection data-id="element-504" />
      <ProgramsOverview data-id="element-505" />
      <TrialSpotlight data-id="element-506" />
      <AreasServed data-id="element-507" />
      <SocialProof data-id="element-508" />

      {/* Final Conversion CTA */}
      <section className="py-20 bg-primary text-white text-center" data-id="element-509">
        <div className="max-w-4xl mx-auto px-4" data-id="element-510">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-511">
            Ready to Start Your Journey?
          </h2>
          <p className="text-xl text-blue-100 mb-8" data-id="element-512">
            Join the Limitless Taekwondo family today.
          </p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-513">
            <Link to="/trial" data-id="element-514">
              <Button size="lg" className="bg-accent hover:bg-accent-dark text-white border-none min-w-[200px]" data-id="element-515">
                Start 4-Week Trial
              </Button>
            </Link>
            <a href="tel:8107753153" data-id="element-516">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white/10 min-w-[200px]" data-id="element-517">
                Call (810) 775-3153
              </Button>
            </a>
          </div>
        </div>
      </section>
    </main>;
}